import './functions';
import URL from './URL';

const Tabs = {
    
    i: (obj, head, preview) => {
        Tabs.obj = obj;
        Tabs.head = head;
        Tabs.content = Tabs.obj.find('.tabs-content');
        Tabs.preview = preview;
        Tabs.hashed = false;
        
        Tabs.setDefaults();
        Tabs.addEvents();
        Tabs.checkHash();
    },
    
    setDefaults: () => {
        
        Tabs.content.each(function () {
            $(this).find('.tabs-content-item').first().addClass('active');
        })
    },
    
    addEvents: () => {
        Tabs.head.parents('.tabs').css('height', Tabs.head.get(0).scrollHeight || '');
        $(window).on('load', function(){
            Tabs.head.parents('.tabs').css('height', Tabs.head.get(0).scrollHeight || '');
            Tabs.obj.find('.tabs-head').addClass('active')
        });
        
        Tabs.head.find('.tabs-head-item').click(function (e) {
            e.preventDefault();
            if ($(window).scrollTop() !== Tabs.content.offset().top && !Tabs.hashed)
                Tabs.animateScroll();
            if ($(this).hasClass('active'))
                return;
            
            Tabs.head.find('.active').removeClass('active');
            $(this).addClass('active');
            var url = URL.full.substring(0, URL.full.indexOf(URL.hash) == -1 ? URL.full.length : URL.full.indexOf(URL.hash));
            Tabs.content.find('.active').removeClass('active');
            Tabs.content.find('[data-tab="' + $(this).data('tab') + '"]').addClass('active').find('.slick-slider').slick('refresh');
            window.history.pushState(null, null , url + '#' + $(this).data('tab'));
        });
        
        window.Scroll = $(window).scrollTop();
        window.headOffset = Tabs.head.parents('.tabs').next().offset().top - (Tabs.head.parents('.tabs').innerHeight() * 5 / 6);
        
        Tabs.checkScroll();

        $(window).on('orientationchange', function(){
            if (Tabs.hashed)
                return;
            $('html, body').animate({
                scrollTop: 0
            }, 0);

            Tabs.head.parents('.tabs').css('height', Tabs.head.get(0).scrollHeight || '');
        });
        
        $(window).on('scroll', function () {
            Tabs.checkScroll();
        })
    },
    
    checkScroll : () => {
        if ($(window).scrollTop() >= window.Scroll && $(window).scrollTop() > window.headOffset)
                Tabs.head.parents('.dummy').addClass('fixed').parents('.in-hide').removeClass('in-hide');
        else
            if ($(window).scrollTop() < window.headOffset - $('header').height()) {
                Tabs.head.parents('.dummy').removeClass('fixed');
                Tabs.head.parents('.tabs').css('height', Tabs.head.get(0).scrollHeight || '');
            }
    
        window.Scroll = $(window).scrollTop();
    },
    
    animateScroll: () => {
        $('html, body').animate({
            scrollTop: Tabs.content.offset().top - $('header').height() - 85
        }, 550)
    },

    checkHash: () => {
        if (URL.hash.length > 1) {
            var car = URL.hash.substr(1, URL.hash.length).toLowerCase();
            if (!(car = Tabs.head.find('[data-tab="' + car +'"]')).length)
                return;
            Tabs.hashed = true;
            car.click();
            setTimeout(function () {
                Tabs.hashed = false;
            }, 550)
        }
    }
};

export default Tabs;